<div [loading]="loading">
	<gob-my-account [admin]="user"></gob-my-account>
</div>
